import React from "react";
import { X, Ticket, CalendarDays, MapPin } from "lucide-react";
import { useApp } from "../context/AppContext";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export default function TicketQRModal() {
  const { ticketQR, setTicketQR } = useApp();
  if (!ticketQR) return null;
  const verifyUrl = `${BACKEND_URL}/api/ticket/verify/${ticketQR.token}`;
  const qrUrl = `${BACKEND_URL}/api/share/qr?data=${encodeURIComponent(verifyUrl)}`;

  return (
    <div className="fixed inset-0 z-[88] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/85 backdrop-blur-sm" onClick={() => setTicketQR(null)} />
      <div className="relative z-10 w-full max-w-[360px] rounded-3xl bg-[#101012] border border-white/10 overflow-hidden">
        <div className="flex items-center justify-between px-5 h-12 border-b border-white/10">
          <div className="flex items-center gap-2"><Ticket size={16} className="text-[#a98bff]" /><span className="text-[13px] font-semibold tracking-[0.14em] uppercase">Your Ticket</span></div>
          <button onClick={() => setTicketQR(null)} className="w-8 h-8 rounded-full bg-white/5 flex items-center justify-center hover:bg-white/10"><X size={16} /></button>
        </div>
        <div className="p-5 text-center">
          <p className="text-[16px] font-semibold text-white">{ticketQR.event_title}</p>
          {ticketQR.artist && <p className="text-[12px] text-white/45">{ticketQR.artist}</p>}
          <div className="mt-4 mx-auto w-48 h-48 bg-white rounded-xl flex items-center justify-center p-2">
            <img src={qrUrl} alt="Ticket QR" className="w-full h-full" />
          </div>
          <div className="mt-4 space-y-1 text-[12px] text-white/60">
            {ticketQR.event_date && <p className="flex items-center justify-center gap-1.5"><CalendarDays size={13} /> {ticketQR.event_date}</p>}
            {ticketQR.location && <p className="flex items-center justify-center gap-1.5"><MapPin size={13} /> {ticketQR.location}</p>}
          </div>
          <p className="mt-3 text-[11px] text-amber-300/70">Present this QR at the door. Valid until the day after the event.</p>
        </div>
      </div>
    </div>
  );
}
